import React from 'react';
import styled from 'styled-components';
import { nanoid } from 'nanoid';

import starIcon from '@lt/components/icons-react/userflow/Star';
import { ContainerText, IconContainer, LabelText, SubtitleBlock, TitleBlock } from '../styles';

type TemplateProps = {
  label: string;
  icon?: React.ReactNode;
  stars?: number;
  children?: React.ReactNode;
};

export const Template = ({ label, icon, stars, children }: TemplateProps) => (
  <Content>
    {icon && (
      <IconContainer>
        {typeof icon === 'string' ? <Icon src={icon} alt={label} /> : icon}
      </IconContainer>
    )}
    <ContainerText>
      <div>
        <LabelText>{label}</LabelText>
        {!!stars && (
          <StarsBlock>
            {[...Array(stars)].map(() => (
              <StyledStarIcon key={`${label}-${nanoid()}`} />
            ))}
          </StarsBlock>
        )}
      </div>
      <Subtitle>{children}</Subtitle>
    </ContainerText>
  </Content>
);

const StarsBlock = styled.div`
  display: inline-block;
  margin-left: 4px;
`;

const StyledStarIcon = styled(starIcon)`
  fill: #ffd600;
  width: 8px;
  height: 8px;
`;

const Icon = styled.img`
  width: 16px;
  height: 16px;
`;

const Content = styled(TitleBlock)`
  padding: 4px 0 6px 8px;
`;

const Subtitle = styled(SubtitleBlock)`
  color: #4d4d4d;
`;
